import { API_PATHS } from "../constants/api-paths";
import { TOP_FUNDS_VARIATION } from "../constants/util";
import { request } from "../core/api.client";

export interface TMutualFundData {
  returns_1_mth: number;
  nav_day_change: number;
  returns_3_mth: number;
  returns_6_mth: number;
  returns_1_yr: number;
  latest_nav: number;
  latest_nav_date: string;
  returns_2_yr: number;
  returns_3_yr: number;
  returns_5_yr: number;
  returns_10_yr: number;
  name: string;
  amcfundscheme_id: number;
  assets_under_management: number;
  bse_scheme_name: string;
  bse_sip_minimum_installment_amount_monthly: number;
  bse_sip_minimum_installment_amount_weekly: number;
  bse_minimum_purchase_amount: number;
  bse_additional_purchase_amount_multiple: number;
  bse_sip_minimum_installment_amount: number;
  bse_sip_minimum_installment_amount_quarterly: number;
  bse_settlement_type: string;
  bse_purchase_allowed: string;
  bse_sip_flag: string;
  vr_rating: number;
  vr_rating_date: string;
  amc_logo: string;
  day_change: number;
  fund_manager: string;
  fund_size: number;
  AMCFund__fund_class: string;
  AMCFund__risk_factor: string;
  AMCFund__amcfund_id: string;
  AMCFund__product_name: string;
  AMCFund__AMC__amc_logo: string;
  AMCFund__fund_manager: string;
  has_invested: string;
  amc_id: string;
  minimum_investment_amount: number;
  type: string;
  fund_type: string;
  bse_sip_monthly_dates: string;
  is_nfo: string;
  bse_start_date: string;
  bse_end_date: string;
  bse_reopening_date: string;
  bse_face_value: string;
  investment_objective: string;
  late_redemption_date: string;
  vr_scheme_type: string;
  nfo_type: string;
  allottment_date: string;
  theme_category: string;
  theme_category_rank: string;
}

export const mutualFundApiCall = async (fundType: string, limit: number) => {
  const fundName =
    fundType.toLowerCase().replaceAll(/\s+/g, "") === TOP_FUNDS_VARIATION.TAXSAVER
      ? TOP_FUNDS_VARIATION.ELSS
      : fundType;
  const response = await request<TMutualFundData[]>({
    method: "GET",
    url: `${API_PATHS.mutualFund}?type=${fundName.replaceAll(/\s+/g, "").toLowerCase()}&limit=${limit}`,
  });
  return response;
};
